import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const container = document.getElementById("root");
const normalizePath = pathname => pathname.replace(/\/+$/, "") || "/";
const matchesPrerender = container.dataset.prerendered === "true" &&
  container.dataset.prerenderPath === normalizePath(window.location.pathname);
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if (matchesPrerender) {
  // Retain the complete page while its lazy route loads, then attach events.
  // createRoot would clear that HTML and briefly show the loading spinner.
  ReactDOM.hydrateRoot(container, app);
} else {
  // A host may fall back to the homepage HTML for an unknown/admin route.
  // Discard only its generated head so that stale titles/canonicals do not
  // survive when React renders the actual requested route.
  let insidePrerenderHead = false;
  for (const node of Array.from(document.head.childNodes)) {
    if (node.nodeType === Node.COMMENT_NODE && node.nodeValue === "app-prerender-head:start") {
      insidePrerenderHead = true;
      node.remove();
    } else if (node.nodeType === Node.COMMENT_NODE && node.nodeValue === "app-prerender-head:end") {
      insidePrerenderHead = false;
      node.remove();
    } else if (insidePrerenderHead) {
      node.remove();
    }
  }
  // Development still uses an empty CRA root.
  document.querySelectorAll('[data-prerender-head]').forEach(node => node.remove());
  ReactDOM.createRoot(container).render(app);
}
